import { Row, Col, Modal, Button, notification } from "antd";
import { useState } from "react";
import axios from "axios";
import { DeleteOutlined } from "@ant-design/icons";

import endpoints from "../../utils/endpoints.js";

function Delete({ data, open, close }) {
  const [isButtonLoading, setIsButtonLoading] = useState(false);

  function handleDelete() {
    setIsButtonLoading(true);

    axios
      .post(endpoints.notification.delete, {
        data,
      })
      .then((res) => {
        close();
        setIsButtonLoading(false);
        notification.success({
          message: "Sucesso!",
          description: "Notificação foi apagada com sucesso!",
        });
      })
      .catch((error) => {
        console.log(error);
        setIsButtonLoading(false);
        notification.error({
          message: "Oops!",
          description: "Algo de errado aconteceu! Tente novamente mais tarde.",
        });
      });
  }

  return (
    <Modal
      className="modal-antd-commission"
      title={`Apagar notificação`}
      open={open}
      onCancel={close}
      footer={[
        <Button danger icon={<DeleteOutlined />} size="large" type="primary" onClick={handleDelete} loading={isButtonLoading} disabled={isButtonLoading}>
          Apagar
        </Button>,
        <Button size="large" onClicdk={close}>
          Cancelar
        </Button>,
      ]}
    >
      <Row gutter={[24, 0]}>
        <Col span={24}>
          <p>Tem a certeza que quer apagar a notificação:</p>
          <p className="bold">{data.title}</p>
        </Col>
      </Row>
    </Modal>
  );
}

export default Delete;
